import endpoint from "../../config/endpoints";

export const packagingTypeJson = {
  showSaveNextBtn: true,
  apiBaseURL: endpoint.packagingType,
  changeExcel: endpoint.exportData,
  formPath: "/packaging-type-form",
  screenTitle: "Packaging Type",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "PackagingType",
  showExcelDownload: false,
  excelFileName: "PackagingType",
  excelUrl: "packaging-type-data" + '?sort={"sortOrderNo": "ASC"}',
  formPathView: "/packaging-type-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Packaging Type Name",
      columnKeyName: "packagingName",
      isChecked: true,
    },
    {
      columnDisplayName: "Sort Order Number",
      columnKeyName: "sortOrderNo",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Packaging Type Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "name",
      isMandatory: true,
      uniqueValidation: true,
    },
    {
      label: "Short Name",
      controlType: "textfield",
      placeHolder: "Short Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "shortName",
      isMandatory: true,
    },
    {
      label: "Description",
      controlType: "textfield",
      placeHolder: "Enter Description",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "description",
      isMandatory: true,
    },
    {
      label: "Sort Order No",
      controlType: "textfield",
      placeHolder: "Sort Order Number",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "sortOrderNo",
      isMandatory: true,
    },
  ],
};
